import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { IBoxGroup } from 'src/app/models/interfaces/box-group.interface';
import { BoxDetailContext } from '../box-detail-form-context';
import { BoxGroupFormComponent } from '../box-group-form/box-group-form.component';
import { BoxesFormComponent } from '../boxes-form/boxes-form.component';

@Component({
    selector: 'app-box-group-detail',
    templateUrl: './box-group-detail.component.html',
    styleUrls: ['./box-group-detail.component.scss'],
    imports: [MatTabsModule, BoxGroupFormComponent, BoxesFormComponent]
})
export class BoxGroupDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public boxGroupUpdated: EventEmitter<IBoxGroup> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: BoxDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<BoxDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: BoxDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param boxGroup: Infos de la bannette modifiée.
     */
    public onBoxGroupUpdated(boxGroup: IBoxGroup) {
        this.boxGroupUpdated.emit(boxGroup);
    }

    /** Mise à jour des bannettes du groupe */
    public onBoxesUpdated(boxGroup: IBoxGroup): void {
        this.boxGroupUpdated.emit(boxGroup);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
